import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useResetPasswordControllerResetPasswordMutation } from '@shared/services/apiService/apiService';
import { ResetFormValue } from '../modal/type';

export const useResetPassword = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [useResetPassword, { isLoading }] = useResetPasswordControllerResetPasswordMutation();
  const [errorMsg, setErrorMsg] = useState('');
  const [successMSg, setSuccessMsg] = useState('');

  const { handleSubmit, setValue, ...formMethods } = useForm<ResetFormValue>({
    mode: 'onTouched',
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    setErrorMsg('');
    setSuccessMsg('');

    const token = searchParams.get('token')?.trim() ?? '';
    if (!token) {
      setErrorMsg(t('forgot.resetPassword.missingToken'));
      return;
    }

    const res = await useResetPassword({
      resetPasswordRequestDto: {
        token,
        password: data.password,
      },
    });

    if (res.error) {
      setSuccessMsg('');
      if (res.error.data) {
        setErrorMsg(res.error.data.message);
      } else {
        setErrorMsg(t('forgot.resetPassword.unknownError'));
      }
    } else {
      setErrorMsg('');
      setSuccessMsg(t('forgot.resetPassword.success'));
    }
  });

  return {
    setValue,
    onSubmit,
    errorMsg,
    successMSg,
    isLoading,
    ...formMethods,
  };
};
